import React, { FC } from 'react';
import { Button } from '@ss/mtd-react';

import './index.scss';

interface IProps {
  text?: string;
  buttonText?: string;
  onclick: Function;
}

// 仅社招
const Empty: FC<IProps> = (props) => {
  const { text = '没有数据', buttonText = '确定', onclick } = props;

  return (
    <div className="data_empty">
      <img className="image" src={require('@imgs/no_data.png')} alt="" />
      <div className="text">{text}</div>
      <Button type="primary" className="empty_button" onClick={() => onclick()}>
        {buttonText}
      </Button>
    </div>
  );
};

export default Empty;
